import { Switch as HUISwitch } from '@headlessui/react';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
}

export default function Switch({ checked, onChange, label }: Props) {
  return (
    <label className="flex cursor-pointer items-center gap-x-5">
      <HUISwitch
        checked={checked}
        onChange={onChange}
        className="group bg-grey-50 relative flex h-[16px] min-w-9 cursor-pointer items-center rounded-full p-1 data-checked:bg-blue-100"
      >
        <span
          aria-hidden="true"
          className="pointer-events-none inline-block size-5 -translate-x-3 rounded-full bg-gray-300 transition group-data-checked:translate-x-5 group-data-checked:bg-blue-700"
        />
      </HUISwitch>
      <span className="font-medium select-none">{label}</span>
    </label>
  );
}
